export default function useFiletype() {
  return (filename: string) => {
    const extensionSeparatorIndex = filename.lastIndexOf('.');

    if (
      extensionSeparatorIndex <= 0 ||
      extensionSeparatorIndex === filename.length - 1
    ) {
      return undefined;
    }

    return filename.slice(extensionSeparatorIndex + 1).toLocaleUpperCase();
  };
}
